// Read-only "Address Links" for the Properties tab expanded row — same links as the
// legacy card (newBorrowerTrackRecordCard / TrackRecordPropertyExpandedPanel), V2 styling.
import { useState } from 'react';
import { Box, Link, Typography } from '@material-ui/core';
import { observer } from 'mobx-react';
import { STATE_BUSINESS_SEARCH_URLS } from 'libs/ui/src/lib/components/borrowerBaseballCard/constants';
import { getStreetName, getStreetNumber } from 'libs/ui/src/lib/components/borrowerBaseballCard/utils';
import TrackRecordTitleHistory from 'libs/ui/src/lib/components/borrowerBaseballCard/trackRecordTitleHistory';

export const PropertyAddressLinks = observer(({
  classes,
  property,
  borrowerBaseballCardStore,
}: {
  classes: Record<string, string>;
  property: any;
  borrowerBaseballCardStore: any;
}) => {
  const [titleHistoryOpen, setTitleHistoryOpen] = useState(false);

  const addressParts = `${property.purchaseAddress}, ${property.purchaseCity}, ${property.purchaseState}, ${property.purchaseZipcode}`;
  const googleHref = property.googleLink || `http://www.google.com/search?q=${addressParts}`;
  const zillowHref = property.zillowLink || `http://www.zillow.com/homes/${addressParts}`.replace(/ /g, '-') + '_rb/';

  // Custom links added on the record (e.g. from V1), stored as a JSON-encoded {key, value}[].
  let customLinks: { key: string; value: string }[] = [];
  try {
    customLinks = JSON.parse(property.links) || [];
  } catch {
    customLinks = [];
  }

  const openTitleHistory = async () => {
    if (!borrowerBaseballCardStore?.lookupProperty) return;
    const data = new FormData();
    data.append('form_information', JSON.stringify({
      address: property.fullAddress || addressParts,
      streetNumber: property.streetNumber || getStreetNumber(property.purchaseAddress),
      streetName: property.streetName || getStreetName(property.purchaseAddress),
      city: property.purchaseCity,
      state: property.purchaseState,
      zipCode: property.purchaseZipcode,
    }));
    const response = await borrowerBaseballCardStore.lookupProperty(data);
    borrowerBaseballCardStore.currentCollateral = property;
    borrowerBaseballCardStore.collateralTitleHistory = response?.data?.rows;
    borrowerBaseballCardStore.titleHistoryMatGridStore.currentSelectedIndex = null;
    borrowerBaseballCardStore.titleHistoryMatGridStore.setSelectedRows([]);
    setTitleHistoryOpen(true);
  };

  return (
    <Box>
      <Typography className={classes.entityDetailLabel}>Address Links</Typography>
      {/* Same font size for anchors and the button-based Title History link. */}
      <Box style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', fontSize: 14 }}>
        <Link href={googleHref} target="_blank" rel="noopener noreferrer">Google</Link>
        <Link href={zillowHref} target="_blank" rel="noopener noreferrer">Zillow</Link>
        <Link component="button" onClick={openTitleHistory} style={{ fontSize: 'inherit' }}>Title History</Link>
        <Link
          href={`https://app.sigmacomputing.com/roc360/workbook/Surrounding-ROC-Loans-1bh5ddSdi8pvKcpF23eBgQ?Loan_ID=&Zip_Code=${property.purchaseZipcode}`}
          target="_blank"
          rel="noopener noreferrer"
        >
          Surrounding Roc Loans
        </Link>
        <Link href={STATE_BUSINESS_SEARCH_URLS[property.purchaseState || '']} target="_blank" rel="noopener noreferrer">
          Secretary of State Site
        </Link>
        {customLinks.map((link, index) => (
          <Link key={`${link.key}-${index}`} href={link.value} target="_blank" rel="noopener noreferrer">
            {link.key}
          </Link>
        ))}
      </Box>

      <TrackRecordTitleHistory
        store={borrowerBaseballCardStore?.titleHistoryMatGridStore}
        property={property}
        titleHistory={borrowerBaseballCardStore?.collateralTitleHistory}
        open={titleHistoryOpen}
        setModalOpen={setTitleHistoryOpen}
        handleClose={() => {
          borrowerBaseballCardStore.collateralTitleHistory = null;
          setTitleHistoryOpen(false);
        }}
      />
    </Box>
  );
});
